import {Component, Input, OnChanges, OnInit, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';
import { SaveFavouriteService } from 'src/app/service/saveFavourite.service';
import { MarkUnMarkFavouriteProductLine } from 'src/app/service/markFavourite.service';
import { AmdocsEventBusService } from 'amdocs-core-package';
import { CONSTANTS } from 'src/app/constants';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-quicklinks-menu',
  templateUrl: './quicklinks-menu.component.html',
  styleUrls: ['./quicklinks-menu.component.scss']
})
export class QuicklinksMenuComponent implements OnInit,OnChanges{
 @Input({ required: true }) quickLinks!: boolean;
  public menuOpen = false;
  public assetsPath='';
  public userName:string='';
  public filteredItems: any = [];
  public isApiLoading:boolean=false
  @Output() closeEvent = new EventEmitter<boolean>();
  public markedFavProducts: any =  [

];
  public searchItem: any = '';
  public isFavoritesAvailable: boolean = true;

  

  constructor(private router:Router,private saveFavourite:SaveFavouriteService,private markUnmarkFavouriteService:MarkUnMarkFavouriteProductLine,private eventBus: AmdocsEventBusService,private userService:UserService) {
  }

  ngOnInit(){
    if(this.quickLinks){
      this.open();
    }
  }

  getProductLine(data: any): void {
    this.eventBus.emit(CONSTANTS.EVENTS.PRODUCTLINE_LISTING, data);
  }

  getMyFavouriteProductList(): void {
  let currentPage = this.userService.getCurrentPage();
  // Convert current page name to constant format if needed
  if (currentPage === 'Searchresults') {
    currentPage = CONSTANTS.STATISTICS.SearchResults;
  } else if (currentPage === 'Home') {
    currentPage = CONSTANTS.STATISTICS.Home;
  } else if (currentPage === 'Productline') {
    currentPage = CONSTANTS.STATISTICS.ProductLinePage;
  }
  let data={
    actionType: CONSTANTS.STATISTICS.MyQuickLinks,
    eventType:CONSTANTS.STATISTICS.Activity,
    landingPage:CONSTANTS.STATISTICS.ExcludedParam,
    inPage: currentPage || CONSTANTS.STATISTICS.QuickLinksMenu
  }
  const statsData=this.userService.getStatsticsInput(data); 
    this.markUnmarkFavouriteService
      ?.getFavouriteProductList(statsData)
      .subscribe((list) => {
        if(list){
        this.isFavoritesAvailable = Boolean(
          list?.getMyFavouriteProductLineList?.length
        );
        this.markedFavProducts = list?.getMyFavouriteProductLineList;
        this.saveFavourite.updateFavourites(this.markedFavProducts);
        this.eventBus.emit(CONSTANTS.EVENTS.FAVOURITE, this.markedFavProducts);
        this.isApiLoading=false;
        }
      });
  }

  ngOnChanges(){
    if(this.quickLinks){
      this.open();
      this.getMyFavouriteProductList();
    }
  }

  public open(): void {
    this.menuOpen = true;
    this.quickLinks=false;
    // Retrieve the data from localStorage if available
      const storedFavProducts = localStorage.getItem(CONSTANTS.STORAGE.markedFavoriteProducts);
      if (storedFavProducts) {
        this.markedFavProducts = JSON.parse(storedFavProducts);
      }
  }

  public close(): void {
    this.menuOpen = false;
    this.closeEvent.emit(false);
  }

  public showMenuItem(item:any): boolean {
    return true;
  }

  public removeFavourites(item,isMarkFavourite){
    let param = {
      saveFaouriteProdcutLineInput: {
        SysID:item.SysID,
        name:item.name,
        isMarkFavourite,
      },
    };
    let statisticsdata={
      actionType: isMarkFavourite? CONSTANTS.STATISTICS.FavoriteProductLine : CONSTANTS.STATISTICS.UnMarkFavouriteProductLine,
      landingPage:CONSTANTS.STATISTICS.QuickLinksMenu,
      eventType:CONSTANTS.STATISTICS.Activity,
    }
    const statsData=this.userService.getStatsticsInput(statisticsdata); 
    this.markUnmarkFavouriteService
    ?.markUnmarkFavourite(param,statsData)
    ?.subscribe((data) => {
      this.isFavoritesAvailable =
        data?.markUnMarkFavouriteProductLine?.isSuccess;
        if(this.isFavoritesAvailable){
        const index = this.markedFavProducts.findIndex(favItem => favItem.SysID === item.SysID);

        if (isMarkFavourite) {
          // If item is not in the array (index === -1), add it
          if (index === -1) {
            this.markedFavProducts.push(item);
          }
        } else {
          // If item is in the array, remove it
          if (index !== -1) {
            this.markedFavProducts.splice(index, 1);
          }
        }
           // Store the updated list in localStorage
           localStorage.setItem(
            CONSTANTS.STORAGE.markedFavoriteProducts,
            JSON.stringify(this.markedFavProducts)
          );
        this.eventBus.emit(CONSTANTS.EVENTS.FAVOURITE, this.markedFavProducts);
      }else{
        item.isMarkFavourite=!isMarkFavourite;
        
      }
      this.saveFavourite.updateFavourites(this.markedFavProducts);
    });
    
    
  }
}
